import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { ReactNode } from 'react';

import Space from '@/components/layout/Space';

const useStyles = makeStyles(() => ({
  container: {
    flexGrow: 1,
  },
  left: {
    display: 'flex',
    justifySelf: 'flex-start',
    marginRight: 'auto',
  },
  right: {
    display: 'flex',
    justifySelf: 'flex-end',
    marginLeft: 'auto',
  },
}));

interface LeftRightPositioningProps {
  left?: ReactNode;
  right?: ReactNode;
  className?: string;
  leftClassName?: string;
  rightClassName?: string;
  style?: React.CSSProperties;
}

export const LeftRightPositioning: React.FC<LeftRightPositioningProps> = ({
  left,
  right,
  className,
  leftClassName,
  rightClassName,
  style,
}: LeftRightPositioningProps) => {
  const classes = useStyles();

  return (
    <Space className={clsx(classes.container, className)} style={style}>
      {left && <Space className={clsx(classes.left, leftClassName)}>{left}</Space>}
      {right && <Space className={clsx(classes.right, rightClassName)}>{right}</Space>}
    </Space>
  );
};

export default LeftRightPositioning;
